import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { PackageMaterial } from 'src/app/models/packagematerial';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form';
import { ValidatePackageLevelFields } from 'src/app/commonUI/customValidators/packagelevelfields.validator';
import { ProposalService } from 'src/app/services/proposal.service';
import { PackageLevelTemplate } from 'src/app/models/packageleveltemplate';
import { DunnageType } from 'src/app/models/dunnagetype';
import { Constants } from 'src/app/core/constants';
import { CreateProposalDTO } from 'src/app/models/createproposaldto';
import { UnitOfMeasurement } from 'src/app/models/internal/unit-of-measurement';
import Helper from 'src/app/core/utility/helper';
import { ProposalPackageLevel } from 'src/app/models/proposalpackagelevel';
import { IInnerPackChanged } from 'src/app/core/interfaces/innerpack-change-event.interface';
import { Observable, observable, of } from 'rxjs';
import { MatAutocompleteSelectedEvent } from '@angular/material';
import { PackageLevelTemplateDTO } from 'src/app/models/internal/packageleveltemplate-dto';
import Calculator from 'src/app/core/utility/calculator';
import { BasePage } from 'src/app/core/basepages/allbasepages';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { NGXLogger } from 'ngx-logger';
import { AppSettings } from 'src/app/app.settings';
import { IShippableChanged } from 'src/app/core/interfaces/isshippable-change-event.interface';
import { ProposalPackageLevelDunnageType } from 'src/app/models/ProposalPackageLevelDunnageType';
@Component({
    selector: 'app-packagelevel',
    templateUrl: './packagelevel.component.html',
    styleUrls: ['./packagelevel.component.scss'],
})
export class PackagelevelComponent extends BasePage implements OnInit {
    arrDefinedMaxStackHeights: any = null;
    globalUOM: UnitOfMeasurement;
    packageLevelUOM: UnitOfMeasurement = new UnitOfMeasurement();
    uomUpdatingOnLoad = true;
    convertedMaxWeight: number;
    createProposalDTO: CreateProposalDTO = new CreateProposalDTO();
    ProposalPackageLevelForm: FormGroup;
    childControlTooltipText: string = '';
    @Input() level: number;
    @Input() IsSupplier: boolean;
    @Output() private formReady: EventEmitter<FormGroup> = new EventEmitter<
        FormGroup
    >();
    @Output() formUpdated = new EventEmitter<number>();
    @Output() innerPackChanged = new EventEmitter<IInnerPackChanged>();
    @Output() shippableChanged = new EventEmitter<IShippableChanged>();
    @Output() levelClearClicked = new EventEmitter<number>();
    @Output() templateSelected  = new EventEmitter<PackageLevelTemplate>();
    @Output() templateCleared  = new EventEmitter();
    ContainersPerLayerNote: string;
    ReadonlyNoOfLayersControl: boolean = false;
    ShowInnerPackCheckBox: boolean = false;
    MaxStackHeight: number;
    levelName: string;
    TotalWeight: number;
    TotalContainersInLevel: number;
    TotalPartsInLevel: number;
    TotalPackageHeight: number;
    MaxWeight: number;
    transportModeId: number;
    packageTypeId: number;
    otherDunnageTypeSelected: boolean = false;
    IsDunnageRequiredPrimaryChecked: boolean = false;
    IsDunnageRequiredSecondaryChecked: boolean = false;
    IsDunnageRequiredTertiaryChecked: boolean = false;
    IsInnerPackPrimaryChecked: boolean = false;
    IsInnerPackSecondaryChecked: boolean = false;
    IsShippablePrimaryChecked: boolean = false;
    IsShippableSecondaryChecked: boolean = false;
    DoShowShippableCheckbox: boolean = false;
    public packageMaterialList: PackageMaterial[];
    public dunnageTypePrimaryList: DunnageType[];
    public dunnageTypeSecondaryList: DunnageType[];
    public dunnageTypeTertiaryList: DunnageType[];
    public packagelevelTemplateList: PackageLevelTemplate[];
    public currentUOM: number = Constants.IMPERIAL_UOM_ID;
    IsShippableMaterial: boolean = false;
    ShowWarningfroNonShippableMaterial: boolean = false;
    @Input() isUpdateMode = false;
    percentagePackageUtilization: number;
    percentageWeightUtilization: number;
    dimensionsAndWeightsForSaving = {
        Length: null,
        Width: null,
        Height: null,
        TareWeight: null,
        MaxWeight: null
    };
    public formErrors = {
        PackagelevelTemplateId: '',
        PackageMaterialId: '',
        Length: '',
        Width: '',
        Height: '',
        QPC: '',
        ContainersPerLayer: '',
        NoOfLayers: '',
        TareWeight: '',
        TotalWeight: '',
        proposalPackageLevelDunnageTypes: '',
        DunnageType: '',
        IsShippable: ''
    };
    partWeightInProposal: number;
    filteredMaterialOptions: Observable<PackageMaterial[]>;
    filteredPackageTemplateOptions: Observable<PackageLevelTemplate[]>;
    innerPackserviceSourceTypeIdList: number[];

    constructor(
        private dataService: DataService,
        private fb: FormBuilder,
        private proposalService: ProposalService,
        public FormService: FormService,
        localstorageService: LocalstorageService,
        logger: NGXLogger,
        appSettings: AppSettings
    ) {
        super(localstorageService, logger, appSettings);
        this.ProposalPackageLevelForm = this.fb.group({
            PackageLevelId: [this.level],
            PackagelevelTemplateId: [null],
            PackageMaterialId: [null],
            PackageMaterialOption: [null],
            PackageTemplateOption: [null],
            IsShippable: [false],
            QPC: [null],
            ContainersPerLayer: [null],
            ContainersPerLayerNote: [null],
            NoOfLayers: [null],
            Length: [null],
            Width: [null],
            Height: [null],
            TareWeight: [null],
            MaxWeight: [null],
            TotalWeight: [null],
            TotalPackageHeight: [null],
            IsDunnageRequired: [true],
            IsInnerPack: [false],
            proposalPackageLevelDunnageTypes: [null],
            DunnageType: '',
            ODHeight: [null],
            ODLength: [null],
            ODWidth: [null]
        });
    }


      displayMaterialFn(option: PackageMaterial): string {
        return option && option.Description ? option.Description : '';
      }


      displayPackageTemplateFn(option: PackageLevelTemplate): string {
        return option && option.TeslaEquipmentCode ? option.TeslaEquipmentCode : '';
      }

      GetPackageTemplateCodeDisplayText(option: PackageLevelTemplate): string {
        // convert as necessary

        var length: number = option.ODLength;
        var width: number = option.ODWidth;
        var height: number = option.ODHeight;
        // if current gloabl uom (radio button on basic info tab) is Metric, then only convert (as DB will always have imperial)
        if (this.globalUOM.Id == Constants.METRIC_UOM_ID) {
            length = Helper.roundto8(length * Constants.IMPERIAL_DIM_FACTOR);
            width = Helper.roundto8(width * Constants.IMPERIAL_DIM_FACTOR);
            height = Helper.roundto8(height * Constants.IMPERIAL_DIM_FACTOR);
        }

        var efectiveDates = '';
        if (new Date(option.EffectiveTo) < new Date('9999/12/30')) {
            efectiveDates = ' start: ' + Helper.formatDate(option.EffectiveFrom) + ' end: ' + Helper.formatDate(option.EffectiveTo);
        }

        return option && option.TeslaEquipmentCode ?
                option.TeslaEquipmentCode + " (" + length + " x " + width + " x " + height  + ")" + efectiveDates : '';
      }

    ngOnInit() {

        //TMS-20237 Commenting out the older logic where Inner pack was set to true only for single location
      /*  this.proposalService.sourceTypeId.subscribe(id => {
            // make innerpack checkbox visible only if business location is 'Service'
            this.ShowInnerPackCheckBox = id === Constants.SOURCETYPEID_SERVICE;;
        }); */

        this.proposalService.globalUOMOnUserToggle.subscribe(uom => {
            if (uom) {
            this.globalUOM = uom;
           this.updateMeasurementsOnUserToggle();
            }
        });

        this.proposalService.globalUOMOnLoad.subscribe(uom => {
            if (uom ) {
                this.globalUOM = uom;
                if (this.isUpdateMode) {
                this.updateMeasurementsOnLoad();
                }
                this.updateMaxStackHeight();
            }
        });

        this.proposalService.globalUOMOnSubmit.subscribe(uom => {
            if (uom) {
                if (uom.Id != this.globalUOM.Id) {
                    this.globalUOM = uom;
                   this.actuallyUpdateMeasurements(true, 0, true);
                }
            }
        });

        this.proposalService.createProposalDTO.subscribe(prop => {
            if (prop) {
                this.createProposalDTO = prop;
                this.updateControls(prop);
            }
        });

        this.proposalService.packageTypeId.subscribe(packageTypeId => {
            this.packageTypeId = packageTypeId;
            this.ResetPackageTemplateDependencies();
        });

        this.proposalService.partWeightInProposal.subscribe(weight => {
            this.partWeightInProposal = weight;
        });

        this.proposalService.packageMaterialMasterList.subscribe(packageMaterials => {
            this.packageMaterialList =  packageMaterials;
            this.PackagingMaterialChanged(
                this.ProposalPackageLevelForm.controls[
                    'PackageMaterialId'
                ].value
            );
        });

        this.proposalService.transportModeId.subscribe(id => {
            this.transportModeId = id;
            this.ResetPackageTemplateDependencies();
            this.updateMaxStackHeight();
        });

        this.proposalService.dunnageTypeMasterList.subscribe(dunnageTypes => {
            this.setDunnageTypes(dunnageTypes);

        });
        this.ProposalPackageLevelForm.controls['PackageLevelId'].patchValue(
            this.level
        );

        this.ProposalPackageLevelForm.valueChanges.subscribe(data => {
            this.formUpdated.emit();
        });

        this.proposalService.proposalEstimate.subscribe(estimate => {
            if(estimate && !this.isUpdateMode)
            {
                let currentPackageLevelEstimate = estimate.find(x => x.PackageLevelId == this.level)
                if (!currentPackageLevelEstimate) return;

                if (this.createProposalDTO.DefaultProposal.PackageInfo.ProposalPackageLevels.length < this.level)
                    this.createProposalDTO.DefaultProposal.PackageInfo.ProposalPackageLevels.push(new ProposalPackageLevel());
                let mat = this.packageMaterialList.find(option => option.Description.toLowerCase().includes(currentPackageLevelEstimate.PackageMaterialName.toLowerCase()));
                this.createProposalDTO.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level - 1].PackageMaterialDescription = mat.Description;
                this.createProposalDTO.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level - 1].PackageMaterialId = mat.Id;
                this.createProposalDTO.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level - 1].PackageMaterialIsShippable = mat.IsShippable;
                this.ProposalPackageLevelForm.controls['PackageMaterialOption'].setValue({ Description: mat.Description, IsShippable: mat.IsShippable});
                this.ProposalPackageLevelForm.controls['PackageTemplateOption'].setValue({ TeslaEquipmentCode: currentPackageLevelEstimate.TeslaPackageEquipmentCode});
                this.PackagingMaterialChanged(mat.Id);
                this.createProposalDTO.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level - 1].QPC = currentPackageLevelEstimate.QPC as number;
                this.createProposalDTO.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level - 1].TareWeight = currentPackageLevelEstimate.TareWeight as number;
                // this.createProposalDTO.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level - 1].proposalPackageLevelDunnageTypes = [];
                // this.createProposalDTO.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level - 1].proposalPackageLevelDunnageTypes.push(
                //     new ProposalPackageLevelDunnageType({
                //         DunnageTypeId: currentPackageLevelEstimate.DunnageTypeId as number,
                //         Description: currentPackageLevelEstimate.DunnageTypeDescription,
                //         ProposalPackageLevelId: this.level
                //     }));
                // this.createProposalDTO.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level - 1].DunnageType = currentPackageLevelEstimate.DunnageTypeDescription;
                this.createProposalDTO.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level - 1].TeslaEquipmentCode = currentPackageLevelEstimate.TeslaPackageEquipmentCode;

                // if (this.level > 1) {
                //     this.createProposalDTO.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level - 1].NoOfLayers = currentPackageLevelEstimate.NoOfLayers as number;
                //     this.createProposalDTO.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level - 1].ContainersPerLayer = currentPackageLevelEstimate.ContainersPerLayer as number;
                // }

                if (currentPackageLevelEstimate.TeslaPackageEquipmentCode == null) {
                    this.createProposalDTO.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level - 1].Length = currentPackageLevelEstimate.PackageLength as number;
                    this.createProposalDTO.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level - 1].Width = currentPackageLevelEstimate.PackageWidth as number;
                    this.createProposalDTO.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level - 1].Height = currentPackageLevelEstimate.PackageHeight as number;
                }
                this.updateControls(this.createProposalDTO);
            }
        });

        this.formReady.emit(this.ProposalPackageLevelForm);
        this.updateInnerPackCheckBoxFlag();
        this.proposalService.sourceTypeId.subscribe(id => {
            this.arrDefinedMaxStackHeights = Constants.MAXSTACK[id]; // array of objects will be assigned if defined
            this.updateMaxStackHeight();
         });
    }

    updateMeasurementsOnLoad() {
        const level = this.level;
        if (this.ProposalPackageLevelForm && this.packageLevelUOM.Id) {
            if (this.currentUOM != this.globalUOM.Id) {
                this.actuallyUpdateMeasurements(true);
            }
        }
    }
    updateMeasurementsOnUserToggle() {
        if (this.ProposalPackageLevelForm && this.currentUOM != this.globalUOM.Id) {
            this.actuallyUpdateMeasurements(false);
        }
    }

    actuallyUpdateMeasurements(isOnLoad: boolean, packageSystemUOM: number = 0, isSave = false) {
        if ((this.ProposalPackageLevelForm && this.packageLevelUOM.Id ) && (( this.currentUOM != this.globalUOM.Id) ||
            (packageSystemUOM != 0 && this.globalUOM.Id == Constants.METRIC_UOM_ID))) {
                if (this.dimensionsAndWeightsForSaving.Length || this.dimensionsAndWeightsForSaving.Height || this.dimensionsAndWeightsForSaving.MaxWeight ||
                    this.dimensionsAndWeightsForSaving.Width || this.dimensionsAndWeightsForSaving.TareWeight) {
                        this.setValuesForConversionOrSaving();
                    }
            Helper.updateUOMs(this.ProposalPackageLevelForm, 'Length', false, this.globalUOM);
            Helper.updateUOMs(this.ProposalPackageLevelForm, 'Width', false, this.globalUOM);
            Helper.updateUOMs(this.ProposalPackageLevelForm, 'Height', false, this.globalUOM);
            Helper.updateUOMs(this.ProposalPackageLevelForm, 'MaxWeight', true, this.globalUOM);
            Helper.updateUOMs(this.ProposalPackageLevelForm, 'TareWeight', true, this.globalUOM);
            this.currentUOM = this.globalUOM.Id;
            this.convertMesaurementsForSave();
        }
        if (!isSave) {
            this.convertValuesForDisplay();
        }
    }

    setTotalPackageHeight(values: number[]) {
        this.TotalPackageHeight = values[this.level - 1];
    }

    setTotalWeight(values: number[]) {
        this.TotalWeight = values[this.level - 1];
    }
    setTotalContainersInLevel(values: number[]) {
        this.TotalContainersInLevel = values[this.level - 1];
    }
    setTotalPartsInLevel(values: number[]) {
        this.TotalPartsInLevel = values[this.level - 1];
    }

    SetDoShowShippableCheckbox()
    {
        const IsThisLevelInnerPackChecked = (this.level == Constants.PRIMARY_LEVEL && this.IsInnerPackPrimaryChecked) ||
        (this.level == Constants.SECONDARY_LEVEL && this.IsInnerPackSecondaryChecked);

        this.DoShowShippableCheckbox =  (
            this.level < 3 &&
             IsThisLevelInnerPackChecked &&
            this.IsShippableMaterial
            );
    }

    getDimensionUOMName() {
        if (this.globalUOM) {
        return this.globalUOM.DimensionUoMName;
        } else {
            return '';
        }
    }
    getWeightUOMName() {
        if (this.globalUOM) {
        return this.globalUOM.WeightUoMName;
        } else {
            return '';
        }
    }
    getMaxWeight() {
        // Helper.updateUOMs(this.ProposalPackageLevelForm, 'MaxWeight', true, this.globalUOM);
        return this.ProposalPackageLevelForm.controls['MaxWeight'].value;
    }
    getContainersPerLayer() {
        return this.ProposalPackageLevelForm.controls['ContainersPerLayer'].value;
    }
    getNoOfLayers() {
        return this.ProposalPackageLevelForm.controls['NoOfLayers'].value;
    }
    getTareWeight() {
        return this.ProposalPackageLevelForm.controls['TareWeight'].value;
    }
    getQPC() {
        return this.ProposalPackageLevelForm.controls['QPC'].value;
    }
    updateControls(prop: CreateProposalDTO) {
        if (
            this.ProposalPackageLevelForm &&
            (prop.DefaultProposal.PackageInfo.ProposalPackageLevels.length > this.level - 1)
        ) {
            const ppldtSetter = [];
            const descript = [];
            // if (this.level != 3 && prop.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level - 1].proposalPackageLevelDunnageTypes != null) {
            if (prop.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level - 1].proposalPackageLevelDunnageTypes != null) {
                    prop.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level - 1].proposalPackageLevelDunnageTypes.forEach(x => {
                ppldtSetter.push(x);
                if (x.hasOwnProperty('DunnageTypeId')) {
                    ppldtSetter.push(x.DunnageTypeId);
                }
                descript.push(x.Description);
            }); }
            if (ppldtSetter != null) {
                prop.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level - 1].proposalPackageLevelDunnageTypes = ppldtSetter;
            }
            let tempstring = '';
            if (descript != null) {
                descript.forEach(x => {
                    if (x != undefined && x != 'Other') {
                        tempstring +=  x + ', ';
                    }
                });
            }
            if (prop.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level - 1].proposalPackageLevelDunnageTypes != null) {
            this.proposalService.RefreshPackagingDunnageTypeId(
                ppldtSetter,
                tempstring + prop.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level - 1].DunnageType,
                this.level
            ); }
            this.proposalService.RefreshPackagingTemplateDescription(
                prop.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level - 1].TeslaEquipmentCode,
                this.level
            );
            this.ProposalPackageLevelForm.patchValue(
                prop.DefaultProposal.PackageInfo.ProposalPackageLevels[
                    this.level - 1
                ]
            );
            this.ProposalPackageLevelForm.controls['ODLength'].patchValue(
                prop.DefaultProposal.PackageInfo.ProposalPackageLevels[
                    this.level - 1
                ].Length
            );
            this.ProposalPackageLevelForm.controls['ODWidth'].patchValue(
                prop.DefaultProposal.PackageInfo.ProposalPackageLevels[
                    this.level - 1
                ].Width
            );
            const currentPackageLevel = prop.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level - 1];
            this.ProposalPackageLevelForm.controls['PackageMaterialOption'].setValue({ Description: currentPackageLevel.PackageMaterialDescription, IsShippable:currentPackageLevel.PackageMaterialIsShippable });
            this.ProposalPackageLevelForm.controls['PackageTemplateOption'].setValue({ TeslaEquipmentCode: currentPackageLevel.TeslaEquipmentCode});
            this.IsShippableMaterial = currentPackageLevel.PackageMaterialIsShippable;

            this.globalUOM = Helper.getUoMObject(prop.DefaultProposal.PackageInfo.UOMSystemId);
            const packageUomId = prop.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level - 1].UOMSystemId;

            this.IsDunnageRequiredPrimaryChecked = prop.DefaultProposal.PackageInfo.ProposalPackageLevels[0].IsDunnageRequired;
            this.IsInnerPackPrimaryChecked = prop.DefaultProposal.PackageInfo.ProposalPackageLevels[0].IsInnerPack;
            this.IsShippablePrimaryChecked = prop.DefaultProposal.PackageInfo.ProposalPackageLevels[0].IsShippable;

            if (this.IsInnerPackPrimaryChecked && this.level == 1) {
                const eventParam = {} as IInnerPackChanged;
                eventParam.IsInnerPackChecked = true;
                eventParam.level = 1;
                this.innerPackChanged.emit(eventParam);
            }
            if (this.IsShippablePrimaryChecked && this.level == 1) {
                const eventParam = {} as IShippableChanged;
                eventParam.IsShippablePackChecked = true;
                eventParam.level = 1;
                this.shippableChanged.emit(eventParam);
            }
            if (prop.DefaultProposal.PackageInfo.ProposalPackageLevels && prop.DefaultProposal.PackageInfo.ProposalPackageLevels.length >= 2) {

                if(prop.DefaultProposal.PackageInfo.ProposalPackageLevels.length == 3) {
                    this.IsDunnageRequiredTertiaryChecked  = prop.DefaultProposal.PackageInfo.ProposalPackageLevels[2].IsDunnageRequired;
                }

                this.IsDunnageRequiredSecondaryChecked = prop.DefaultProposal.PackageInfo.ProposalPackageLevels[1].IsDunnageRequired;
                this.IsInnerPackSecondaryChecked = prop.DefaultProposal.PackageInfo.ProposalPackageLevels[1].IsInnerPack;
                this.IsShippableSecondaryChecked = prop.DefaultProposal.PackageInfo.ProposalPackageLevels[1].IsShippable;
                if (this.IsInnerPackSecondaryChecked) {
                    const eventParam = {} as IInnerPackChanged;
                    eventParam.IsInnerPackChecked = true;
                    eventParam.level = 2;
                    this.innerPackChanged.emit(eventParam);
                }

                if (this.IsShippableSecondaryChecked) {
                    const eventParam = {} as IShippableChanged;
                    eventParam.IsShippablePackChecked = true;
                    eventParam.level = 2;
                    this.shippableChanged.emit(eventParam);
                }
                this.SetDoShowShippableCheckbox();

            }
            const Other_DunnageTypeId = this.getDunnageTypeIdForOther();
            // if (this.level != 3)
            {
                if (ppldtSetter != null) {
                this.otherDunnageTypeSelected = ppldtSetter.includes(Other_DunnageTypeId);
                }
            }

            this.PackagingMaterialChanged(
                this.ProposalPackageLevelForm.controls[
                    'PackageMaterialId'
                ].value, true
            );
            this.PackageLevelTemplateChanged(this.ProposalPackageLevelForm.controls[
                'PackagelevelTemplateId'
            ].value, true
            );
            this.convertMesaurementsForSave();
            this.convertValuesForDisplay();
        }
    }

    updatePackageLevelUOM(packageUomId: number) {
        this.packageLevelUOM = Helper.getUoMObject(packageUomId);
        // this.updateMeasurementsOnLoad();

    }



    // in case of update this will be called by main proposal component
    // setControlValues(createProposalDTO: CreateProposalDTO) {
    //     this.createProposalDTO = createProposalDTO;
    //     this.isUpdateMode = true;
    //     const prop = createProposalDTO.DefaultProposal;
    //     if (
    //         this.ProposalPackageLevelForm &&
    //         prop.PackageInfo.ProposalPackageLevels[this.level - 1]
    //     ) {
    //         this.ProposalPackageLevelForm.patchValue(
    //             prop.PackageInfo.ProposalPackageLevels[
    //                 this.level - 1
    //             ]
    //         );
    //     }
    //     this.PackagingMaterialChanged(
    //         this.ProposalPackageLevelForm.controls[
    //             'PackageMaterialId'
    //         ].value
    //     );
    //     // this.getMaterials(prop.PackageInfo.PackageTypeId).subscribe(
    //     //     (response: any) => {
    //     //         if (response && response.Data != null) {

    //     //         }
    //     //     }
    //     // );
    // }

    ResetPackageTemplateDependencies() {
        this.ProposalPackageLevelForm.controls['PackageMaterialId'].patchValue(
            null
        );
        this.packagelevelTemplateList = [];
        this.ProposalPackageLevelForm.controls[
            'PackagelevelTemplateId'
        ].patchValue(null);
    }
    PackagingTemplateAutoCompleteSelected(event: MatAutocompleteSelectedEvent) {
        const UpdatedPackageTemplateId = event.option.value.Id;
        this.ProposalPackageLevelForm.controls['PackagelevelTemplateId'].patchValue(UpdatedPackageTemplateId);
        this.PackageLevelTemplateChanged(UpdatedPackageTemplateId);
    }

    PackagingTemplateFilterChanged(event: any) {
        const value = event.target.value;
        const filterValue = value.toLowerCase();
        this.filteredPackageTemplateOptions = of(<PackageLevelTemplate[]>(this.packagelevelTemplateList.filter(option => option.TeslaEquipmentCode.toLowerCase().includes(filterValue))));
      }
      PackagingMaterialFilterChanged(event: any) {
        const value = event.target.value;
        const filterValue = value.toLowerCase();
        this.filteredMaterialOptions = of(<PackageMaterial[]>(this.packageMaterialList.filter(option => option.Description.toLowerCase().includes(filterValue))));
        this.ResetInnerPackShippable();
        this.SetDoShowShippableCheckbox();
      }

      ResetInnerPackShippable()
      {
        this.ProposalPackageLevelForm.controls['IsInnerPack'].patchValue(false);
        this.ProposalPackageLevelForm.controls['IsShippable'].patchValue(false);
        this.SetInnerPackFlags(this.level, false);
        this.DoShowShippableCheckbox = false;
      }
    PackagingMaterialAutoCompleteSelected(event: MatAutocompleteSelectedEvent) {
        const UpdatedPackageMaterialId = event.option.value.Id;
        this.IsShippableMaterial = event.option.value.IsShippable;
        // update isshippable to default only if service location i.e. inner pack to be shown
        if(this.ShowInnerPackCheckBox)
        {
            this.ProposalPackageLevelForm.controls['IsShippable'].patchValue(this.IsShippableMaterial);
        }
        this.ProposalPackageLevelForm.controls['PackageMaterialId'].patchValue(UpdatedPackageMaterialId);
        this.PackagingMaterialChanged(UpdatedPackageMaterialId);
    }

    PackagingMaterialChanged(id: number, isOnload: boolean = false) {
        if (id) {
            this.logDebug('PackagingMaterialChanged', id);
        }

        let dtoMaterialId = 0;
        if (this.createProposalDTO
            && this.createProposalDTO.DefaultProposal
            && this.createProposalDTO.DefaultProposal.PackageInfo
            && this.createProposalDTO.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level -1]
            && this.createProposalDTO.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level -1].PackageMaterialId)
        {
            dtoMaterialId =this.createProposalDTO.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level -1].PackageMaterialId;
        }

        // TMS-6334
        //tms-36170 mark inner pack to null and don't show isshippable flag if user try to change package material
        if (!isOnload && id != dtoMaterialId) {
            this.packagelevelTemplateList = null; // avoid showing old list if user quickly clicks template code search
            this.ProposalPackageLevelForm.controls['PackagelevelTemplateId'].patchValue(null);
            this.ProposalPackageLevelForm.controls['PackageTemplateOption'].setValue({ TeslaEquipmentCode: null});
            this.ProposalPackageLevelForm.controls['IsInnerPack'].patchValue(false);
            // this.IsShippableMaterial = false;
        }


        if (id && this.packageMaterialList && this.packageMaterialList.length > 0) {
            const packagingMaterialDescription = this.packageMaterialList.find(
                a => a.Id == id
            ).Description;

            this.proposalService.RefreshPackagingMaterialId(
                id,
                packagingMaterialDescription,
                this.level
            );
            if(this.ProposalPackageLevelForm.controls['PackageMaterialOption'].value.IsShippable != undefined)
            {
                this.IsShippableMaterial = this.ProposalPackageLevelForm.controls['PackageMaterialOption'].value.IsShippable == true ? true : false;
            }
            // if(this.createProposalDTO.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level - 1])
            // {
            // this.IsShippableMaterial = this.createProposalDTO.DefaultProposal.PackageInfo.ProposalPackageLevels[this.level - 1].IsShippable == true ? true : false;
            // }
            this.ShowWarningfroNonShippableMaterial = this.ProposalPackageLevelForm.controls['PackageMaterialOption'].value.IsShippable == false ? true : false;

            // this.getPackageLevelTemplates(this.level, this.materrialId, this.transportModeId, this.packageTypeId);
            this.RefreshPackageLevelTemplates(isOnload);
        }
    }

    RefreshPackageLevelTemplates(isOnload: boolean = false) {
        const PackagelevelTemplateIdToSet = null;
        const materialId = this.ProposalPackageLevelForm.controls[
            'PackageMaterialId'
        ].value;
        this.getPackageLevelTemplates(
            this.level,
            materialId,
            this.transportModeId,
            this.packageTypeId,
            isOnload
        );
        // .subscribe((response: any) => {
        //     if (response && response.Data != null) {
        //         this.packagelevelTemplateList = response.Data;
        //         if (
        //             this.createProposalDTO.DefaultProposal.PackageInfo
        //                 .ProposalPackageLevels &&
        //             this.createProposalDTO.DefaultProposal.PackageInfo
        //                 .ProposalPackageLevels.length > 0
        //         ) {
        //             PackagelevelTemplateIdToSet = this.createProposalDTO
        //                 .DefaultProposal.PackageInfo.ProposalPackageLevels[
        //                 this.level - 1
        //             ].PackagelevelTemplateId;
        //         }
        //         if (this.isUpdateMode && PackagelevelTemplateIdToSet) {
        //             this.ProposalPackageLevelForm.controls[
        //                 'PackagelevelTemplateId'
        //             ].setValue(PackagelevelTemplateIdToSet);
        //             this.PackageLevelTemplateChanged(
        //                 PackagelevelTemplateIdToSet
        //             );
        //         }
        //     }
        // });
    }

    IsDunnageRequiredChanged(event) {
        if (this.level == 1) {
            this.IsDunnageRequiredPrimaryChecked = event.checked;
        } else if (this.level == 2) {
            this.IsDunnageRequiredSecondaryChecked = event.checked;
        } else { (this.level == 3); }
        {
            this.IsDunnageRequiredTertiaryChecked = event.checked;
        }
    }
    //tms-36170 Update inner pack logic, wrt shippable material checkbox
    IsInnerPackChanged(event) {
        const eventParam = {} as IInnerPackChanged;
        eventParam.IsInnerPackChecked = event.checked;
      //  this.ShowShippableCheckbox = eventParam.IsInnerPackChecked ? true : false;
        eventParam.level = this.level;
        this.innerPackChanged.emit(eventParam);
        // even though material may be shippable, let supplier explicitely state that it is shippable if innerpack is selected so set it to false on innercheck checked event
        if (eventParam.IsInnerPackChecked) {
            this.ProposalPackageLevelForm.controls['IsShippable'].patchValue(false);
        }  else if (this.ProposalPackageLevelForm.controls['IsShippable'].value != this.IsShippableMaterial) {
            //this condition is so that if user toggles innerPack checkbox couple times and ends up being false, IsShippable  for the layer should reflect the value of the material template not false!!!
            this.ProposalPackageLevelForm.controls['IsShippable'].patchValue(this.IsShippableMaterial);

        }
        this.SetInnerPackFlags(this.level, event.checked);
        this.SetDoShowShippableCheckbox();
    }

    //tms-36170 set is shippable value based on inner pack, package material and check/uncheck for isshippable checkbox
    IsShippableChanged(event) {
        const eventParam = {} as IShippableChanged;
        eventParam.IsShippablePackChecked = event.checked;
        if (eventParam.IsShippablePackChecked && this.ProposalPackageLevelForm.controls['IsInnerPack'].value == true && this.ProposalPackageLevelForm.controls['PackageMaterialOption'].value.IsShippable == true) {
              this.ProposalPackageLevelForm.controls['IsShippable'].patchValue(true);
          }
        else if (!eventParam.IsShippablePackChecked && this.ProposalPackageLevelForm.controls['IsInnerPack'].value == true && this.ProposalPackageLevelForm.controls['PackageMaterialOption'].value.IsShippable == true) {
              this.ProposalPackageLevelForm.controls['IsShippable'].patchValue(false);
          }
          else {
              this.ProposalPackageLevelForm.controls['IsShippable'].patchValue(this.ProposalPackageLevelForm.controls['PackageMaterialOption'].value.IsShippable);
          }
        eventParam.level = this.level;
        this.shippableChanged.emit(eventParam);
    }

    SetInnerPackFlags(levelChanged: number, IsInnerPackSelected: boolean) {
        // set flag variable and refresh next (parent) level
        if (levelChanged == 1) {
            this.IsInnerPackPrimaryChecked = IsInnerPackSelected;
            this.RefreshDisplayForInnerPackChange(2, IsInnerPackSelected);
        } else if (levelChanged == 2) {
            this.IsInnerPackSecondaryChecked = IsInnerPackSelected;
            this.RefreshDisplayForInnerPackChange(3, IsInnerPackSelected);
        }
    }

    SetShippableFlags(levelChanged: number, IsShippableSelected: boolean) {
        // TMS-41178 - if non-service location then don't do anything. ShowInnerPackCheckBox is false for non-service.
        if(!this.ShowInnerPackCheckBox)
        {
            return;
        }
        // set flag variable and refresh next (parent) level
        if (levelChanged == 1) {
            this.IsShippablePrimaryChecked = IsShippableSelected;
        } else if (levelChanged == 2) {
            this.IsShippableSecondaryChecked = IsShippableSelected;
        }
    }
    RefreshDisplayForInnerPackChange(levelToRefresh: number, IsPreviousInnerPackSelected: boolean) {
        if (this.level == levelToRefresh) {
            const noOfLayersControl = this.ProposalPackageLevelForm.controls['NoOfLayers'];
            const containersPerLayerControl = this.ProposalPackageLevelForm.controls['ContainersPerLayer'];
            const containersPerLayerNoteControl = this.ProposalPackageLevelForm.controls['ContainersPerLayerNote'];
            if (IsPreviousInnerPackSelected) {
                noOfLayersControl.patchValue(1);
                this.ReadonlyNoOfLayersControl = true;
                containersPerLayerControl.patchValue('');
                this.ContainersPerLayerNote = 'Please input total number of innerpacks per box';
            } else {
                noOfLayersControl.patchValue('');
                this.ReadonlyNoOfLayersControl = false;
                containersPerLayerControl.patchValue('');
                this.ContainersPerLayerNote = '';
            }
        }
    }
    PackageLevelTemplateChanged(id: number, isOnload = false, isOnloadWeight: boolean = false) {
        if (this.packagelevelTemplateList && this.packagelevelTemplateList.length > 0) {
        const template = this.packagelevelTemplateList.find(a => a.Id == id);
            if (template) {
                this.templateSelected.emit(template);
                this.packageLevelUOM = Helper.getUoMObject(template.UOMSystemId);
                if (!isOnload) {
                    this.ProposalPackageLevelForm.controls['Length'].patchValue(
                        template.ODLength
                    );
                    this.ProposalPackageLevelForm.controls['Width'].patchValue(
                        template.ODWidth
                    );
                    this.ProposalPackageLevelForm.controls['Height'].patchValue(
                        template.ODHeight
                    );
                    this.ProposalPackageLevelForm.controls['ODLength'].patchValue(
                        template.ODLength
                    );
                    this.ProposalPackageLevelForm.controls['ODWidth'].patchValue(
                        template.ODWidth
                    );
                    this.ProposalPackageLevelForm.controls['ODHeight'].patchValue(
                        template.ODHeight
                    );
                }
            if (!isOnloadWeight) {
                this.ProposalPackageLevelForm.controls['TareWeight'].patchValue(
                    template.TareWeight);
                this.ProposalPackageLevelForm.controls['MaxWeight'].patchValue(
                    template.MaxWeight);
            }
            this.actuallyUpdateMeasurements(isOnload, template.UOMSystemId);
            this.proposalService.RefreshPackagingTemplateDescription(
                template.TeslaEquipmentCode,
                this.level
            );
            this.ValidateForm(false);
            // this.updatePackageLevelUOM(template.UOMSystemId);
            }

        }
    }
    DunnageTypeChanged(proposalPackageLevelDunnageTypes: []) {
        const Other_DunnageTypeId = this.getDunnageTypeIdForOther();
        // this.otherDunnageTypeSelected = dunnageType.toUpperCase() == 'OTHER';
        // if (!this.otherDunnageTypeSelected) {
        //     this.ProposalPackageLevelForm.controls['DunnageType'].patchValue(
        //         dunnageTypes
        //     );
        // } else {
        //     this.ProposalPackageLevelForm.controls['DunnageType'].patchValue(
        //         ''
        //     );
        // }
        let listToSearch: DunnageType[];
        if (this.level == 1) {
            listToSearch = this.dunnageTypePrimaryList;
        } else if (this.level == 2) {
            listToSearch = this.dunnageTypeSecondaryList;
        } else {
            listToSearch = this.dunnageTypeTertiaryList;
        }
        let dunnageTypeDescription: string[];
        dunnageTypeDescription = proposalPackageLevelDunnageTypes.map(x => listToSearch.find(a => a.Id == x).Description);
        this.logDebug(dunnageTypeDescription.join(', '));
        this.proposalService.RefreshPackagingDunnageTypeId(
            proposalPackageLevelDunnageTypes,
            dunnageTypeDescription.join(', '),
            this.level
        );
        this.otherDunnageTypeSelected =  proposalPackageLevelDunnageTypes.find(x => x == Other_DunnageTypeId) ? true : false;
        if (!this.otherDunnageTypeSelected) {
            this.ProposalPackageLevelForm.controls['DunnageType'].patchValue(
                ''
            );
        }
        this.ValidateForm(false);
    }

    // each level as id for 'Other' option of dunnagetype
    getDunnageTypeIdForOther() {
        let Other_DunnageTypeId = 0;
        if (this.level == 1) {
            Other_DunnageTypeId = 7;
        } else if (this.level == 2) {
            Other_DunnageTypeId = 11;
        } else {
            Other_DunnageTypeId = 23;
        }
        return Other_DunnageTypeId;
    }

    // getMaterials(packageTypeId: number): Observable<PackageMaterial[]> {
    //     return this.dataService.getMaterials(packageTypeId);
    //     // if (packageTypeId > 0) {
    //     //     return this.dataService.getMaterials(packageTypeId);
    //     // }
    // }

    setDunnageTypes(dunnageTypes: any) {
            if (dunnageTypes) {
                this.dunnageTypePrimaryList = dunnageTypes.filter(
                    a => a.PackageLevelId == Constants.PRIMARY_LEVEL
                );
                this.dunnageTypeSecondaryList = dunnageTypes.filter(
                    a => a.PackageLevelId == Constants.SECONDARY_LEVEL
                );
                this.dunnageTypeTertiaryList = dunnageTypes.filter(
                    a => a.PackageLevelId == Constants.TERTIARY_LEVEL
                );
            }
    }

    createArrayElementForThisLevel() {
        // get proposal id from previous level
        const proposalId = this.createProposalDTO
        .DefaultProposal.PackageInfo.ProposalPackageLevels[
        this.level - 2
            ].ProposalId;
        this.createProposalDTO
                            .DefaultProposal.PackageInfo.ProposalPackageLevels.push(new ProposalPackageLevel());
        this.createProposalDTO
                            .DefaultProposal.PackageInfo.ProposalPackageLevels[
                            this.level - 1
                        ].ProposalId = proposalId;
                        // this.createProposalDTO
                        //     .DefaultProposal.PackageInfo.ProposalPackageLevels[
                        //     this.level - 1
                        // ].Id = proposalId;
    }

    getPackageLevelTemplates(
        packageLevelId: number,
        packageMaterialId: number,
        transportModeId: number,
        packageTypeId: number,
        isOnload: boolean = false
    ) {
        let PackagelevelTemplateIdToSet = null;
        if (packageMaterialId > 0 && transportModeId > 0 && packageTypeId > 0) {
            //  &&       (!this.packagelevelTemplateList || this.packagelevelTemplateList.length == 0))
            this.dataService.getPackageLevelTemplates(
                this.level,
                packageMaterialId,
                transportModeId,
                packageTypeId,
                this.IsSupplier,
                this.createProposalDTO.DefaultProposal.PartInfo.Parts[0].SupplierCode,
                this.createProposalDTO.DefaultProposal.PackageInfo.ProposalPackageLevels.map(level => level.PackagelevelTemplateId)
            ).subscribe((response: any) => {
              console.log('getting package level templates', response);
                if (response && response.Data != null) {
                    this.packagelevelTemplateList = response.Data;
                    if (
                        this.createProposalDTO.DefaultProposal.PackageInfo
                            .ProposalPackageLevels &&
                        this.createProposalDTO.DefaultProposal.PackageInfo
                            .ProposalPackageLevels.length > 0
                    ) {
                        // in case of update, user may insert new level so create new array element before proceeding
                        if (this.isUpdateMode && this.createProposalDTO
                            .DefaultProposal.PackageInfo.ProposalPackageLevels.length < this.level) {
                                this.createArrayElementForThisLevel();
                            }
                        PackagelevelTemplateIdToSet = this.createProposalDTO
                            .DefaultProposal.PackageInfo.ProposalPackageLevels[
                            this.level - 1
                        ].PackagelevelTemplateId;
                    }

                        if (!this.isUpdateMode && this.createProposalDTO.EstimateProposal.length > 0) {
                            let template = this.packagelevelTemplateList
                                .find(x => x.TeslaEquipmentCode == this.createProposalDTO.EstimateProposal[this.level - 1].TeslaPackageEquipmentCode);
                            if (template) {
                                this.PackageLevelTemplateChanged(template.Id);
                                this.formErrors.PackagelevelTemplateId = null;
                                this.ProposalPackageLevelForm.controls['PackageTemplateOption'].setValue(template);
                                this.ProposalPackageLevelForm.controls['PackagelevelTemplateId'].patchValue(template.Id);
                                this.ValidateForm(false);
                            }
                        }

                    if (this.isUpdateMode && PackagelevelTemplateIdToSet) {
                        this.ProposalPackageLevelForm.controls[
                            'PackagelevelTemplateId'
                        ].setValue(PackagelevelTemplateIdToSet);
                        if (isOnload) {
                            this.PackageLevelTemplateChanged(PackagelevelTemplateIdToSet, true, true);
                        } else {
                            this.PackageLevelTemplateChanged(PackagelevelTemplateIdToSet, true, false);
                        }
                        // this.PackageLevelTemplateChanged(
                        //     PackagelevelTemplateIdToSet
                        // );
                    }
                }
            });
        }
    }

    ValidateForm(IsForSubmit: boolean = true) {

        this.ProposalPackageLevelForm.controls[
            'TotalWeight'
        ].setErrors(null);
        this.ProposalPackageLevelForm.controls['TareWeight'].setErrors(null);
        this.formErrors.TotalWeight = '';
        this.formErrors.TareWeight = '';
        const maxWeight = this.getMaxWeight();
        // TMS-7254 Do all validations only if submitting. For saving draft do only 'required field' validation
        if (IsForSubmit) {
            this.ProposalPackageLevelForm.controls['TareWeight'].setValidators([Validators.pattern('[0-9]*(\.[0-9]{1,4})?')]);
            if (maxWeight && maxWeight > 0 && this.TotalWeight > maxWeight) {
                this.ProposalPackageLevelForm.controls[
                    'TotalWeight'
                ].setErrors({ totalWeightExceedsMaxAllowed: true });
            }
            if (this.ProposalPackageLevelForm.controls['PackageMaterialId'].value) {
                this.ProposalPackageLevelForm = Helper.ValidatePackageTemplateLevelFields(this.ProposalPackageLevelForm, this.formErrors, this.globalUOM);
            }
        }
        this.formErrors = this.FormService.validateForm(
            this.ProposalPackageLevelForm,
            this.formErrors, null, !IsForSubmit
        );
        this.formErrors = ValidatePackageLevelFields(
            this.ProposalPackageLevelForm,
            this.formErrors,
            true, !IsForSubmit
        );
        // mark form as invalid if any field in formErrors is populated
        if (
            Object.values(this.formErrors).find(function(element) {
                if (element) {
                    return element.length > 0;
                } else {
                    return false;
                }
            })
        ) {
            Object.keys(this.formErrors).forEach(field => {
                // this.ProposalPackageLevelForm.controls[field].setErrors({ field: true});
            });
        }
    }

    validateInputFields() {
        this.formErrors = {
            PackagelevelTemplateId: '',
            PackageMaterialId: '',
            Length: '',
            Width: '',
            Height: '',
            QPC: '',
            ContainersPerLayer: '',
            NoOfLayers: '',
            TareWeight: '',
            TotalWeight: '',
            proposalPackageLevelDunnageTypes: '',
            DunnageType: '',
            IsShippable: '',
        };
        ValidatePackageLevelFields(this.ProposalPackageLevelForm, this.formErrors, true, true);
    }

    clear() {
        this.templateCleared.emit();
        this.ProposalPackageLevelForm.reset();
        this.levelClearClicked.emit(this.level);
        this.ProposalPackageLevelForm.controls['PackageLevelId'].patchValue(
            this.level
        );
        this.ProposalPackageLevelForm.controls['IsDunnageRequired'].patchValue(
            false
        );
        this.ProposalPackageLevelForm.controls['IsInnerPack'].patchValue(
            false
        );
        this.ProposalPackageLevelForm.controls['IsShippable'].patchValue(
            false
        );
        this.ProposalPackageLevelForm.controls['ContainersPerLayer'].patchValue(
            1
        );
        this.ProposalPackageLevelForm.controls['PackageMaterialId'].patchValue(
            null
        );
        this.formErrors = {
            PackagelevelTemplateId: '',
            PackageMaterialId: '',
            Length: '',
            Width: '',
            Height: '',
            QPC: '',
            ContainersPerLayer: '',
            NoOfLayers: '',
            TareWeight: '',
            TotalWeight: '',
            proposalPackageLevelDunnageTypes: '',
            DunnageType: '',
            IsShippable: '',
        };
        this.packageLevelUOM.Name = '';
        this.formUpdated.emit();
    }

    convertValuesForDisplay() {
        Helper.convertValueForDisplay(this.ProposalPackageLevelForm, this.dimensionsAndWeightsForSaving);
    }

    convertMesaurementsForSave () {
        this.dimensionsAndWeightsForSaving.Height = this.ProposalPackageLevelForm.controls['Height'].value;
        this.dimensionsAndWeightsForSaving.Length = this.ProposalPackageLevelForm.controls['Length'].value;
        this.dimensionsAndWeightsForSaving.Width = this.ProposalPackageLevelForm.controls['Width'].value;
        this.dimensionsAndWeightsForSaving.TareWeight = this.ProposalPackageLevelForm.controls['TareWeight'].value;
        this.dimensionsAndWeightsForSaving.MaxWeight = this.ProposalPackageLevelForm.controls['MaxWeight'].value;
    }

    setValuesForConversionOrSaving() {
        Helper.setValuesInForm(this.ProposalPackageLevelForm, this.dimensionsAndWeightsForSaving);
    }

    setpercentagePackageUtilization(partInfoForm, proposalPackageLevelInfoForm) {
            const totalPartsInLevel = this.TotalPartsInLevel;
            const percentagePackageUtilization  = Helper.getPercentagePackageUtilization(partInfoForm, proposalPackageLevelInfoForm, totalPartsInLevel);
            this.percentagePackageUtilization = Math.min(100, percentagePackageUtilization);
    }

    setWeightPercentageUtilization(partWeight, arrTotalWeights) {
        const thisLevelTotalWeight = arrTotalWeights[this.level - 1];
        const percentageWeightUtilization = Helper.roundto3(((partWeight * this.TotalPartsInLevel) / thisLevelTotalWeight) * 100);
        this.percentageWeightUtilization = Math.min(100, percentageWeightUtilization);
    }
    refreshToolTipText(code: string) {
        this.childControlTooltipText = Constants[code];
    }

    //TMS-20237 Consume list of inner pack st ids and call function which can mark innerpack flag to true if proposal st locations exists
    updateInnerPackCheckBoxFlag() {
        this.proposalService.innerPackSourcetypeMasterList.subscribe(sourceTypeIds => {
            this.innerPackserviceSourceTypeIdList = sourceTypeIds;
            if (this.innerPackserviceSourceTypeIdList != null) {
                this.setInnerPackFlagValue();
            }
        });
    }


    /* TMS-20237 make innerpack checkbox visible only if business location is 'Service' and 'Service Shanghai' */
    setInnerPackFlagValue() {
        this.proposalService.sourceTypeId.subscribe(id => {
            if (this.innerPackserviceSourceTypeIdList.includes(id)) {
                this.ShowInnerPackCheckBox = true;
            }
        });
    }
    updateMaxStackHeight()
    {
        this.MaxStackHeight = 20; // default
        if(this.arrDefinedMaxStackHeights && this.transportModeId && this.globalUOM)
        {
            const definedMaxStackHeightObj = this.arrDefinedMaxStackHeights.find(o => o.transportmodeid == this.transportModeId);
            if(definedMaxStackHeightObj)
            {
                this.MaxStackHeight = Helper.calculateDim(definedMaxStackHeightObj.maxstackheight, this.globalUOM, false);
            }
        }
        // return this.MaxStackHeight;
    }
}
